import React, { Fragment, useState, useRef } from 'react';
import { connect } from 'react-redux';
import PostsTable from './table';

const PostsList = () => (
  <div>
    <>
      <div className="content-header">
        <h1>Posts</h1>
      </div>

      <PostsTable />
    </>
  </div>
);

PostsList.postTypes = {
};

export default connect(null, {
})(PostsList);
